import styled from 'styled-components'

import { useTranslation } from 'react-i18n-lite'

import {
  AutocompleteUniselection,
  FilteractionObject
} from '@yes.technology/react-toolkit'

import { useSiteState } from 'siteState/shared'

type Filteraction = Pick<
  FilteractionObject,
  'uuid' | 'des' | 'query' | 'complement'
>

export type FilteractionSelectionProps = {
  value: string
  filteractions: Filteraction[]
  onSelectFilteraction: (filteraction?: Filteraction) => void
  setValue: (value: string) => void
}

const Container = styled.div`
  width: 100%;

  @media (min-width: 767px) {
    max-width: 672px;
  }
`

export default function FilteractionSelection({
  filteractions,
  value,
  setValue,
  onSelectFilteraction
}: FilteractionSelectionProps) {
  const { t } = useTranslation()

  const [, setFilteractionName] = useSiteState<string>('filteraction-name')

  const sortedFilteractions = filteractions.sort(
    (a, b) => parseInt(a.complement) - parseInt(b.complement)
  )

  const options = sortedFilteractions.map(({ uuid, des }) => ({
    id: uuid,
    value: des
  }))

  const onChange = (newValue: string | { des: string; uuid: string }) => {
    const newValueString =
      typeof newValue === 'string' ? newValue : newValue.des

    setFilteractionName(newValueString)

    setValue(newValueString)

    onSelectFilteraction(
      filteractions.find((filteraction) => filteraction.des === newValueString)
    )
  }

  return (
    <Container>
      <AutocompleteUniselection
        label={t('filteraction-selection.label')}
        statusClass={value ? 'valid' : 'default'}
        {...{ value, options, onChange }}
      />
    </Container>
  )
}
